export default __webpack_public_path__ + "static/media/Sharks.06fcb0d9.png";